import AdEditor from './AdEditor';
export default AdEditor;
